import moment from 'moment'
import Subject from './Subject'
import Chapter from './Chapter'

export default class Book {
  constructor (data, childProgress = null) {
    if (!data || !data.id) throw new Error('Invalid book data.')

    this.id = data.id

    this.title = data.title ?? ''

    this.author = data.author ?? ''

    this.imageUrl = data.cover ?? null

    this.subject = data.subject ? new Subject(data.subject) : {}

    this.levelFrom = data.level_from ?? 0
    this.levelTo = data.level_to ?? 0
    this.createdAt = data.created_at ? moment(data.created_at) : null
    this.publisher = data.publisher ?? ''
    this.copyright = data.copyright ?? ''

    this.chapters = data.chapters ? data.chapters.map(data => new Chapter(data)) : []

    this.progress = childProgress
  }

  get levelText () {
    const count = Math.abs(this.levelTo - this.levelFrom) + 1
    const array = Array.from({ length: count }, (_, i) => i + this.levelFrom)
    return array.join(', ')
  }

  get authorsText () {
    return this.author.replace(/\.\s/g, '.&nbsp;')
  }
}
